<template>
  <span>
    <widget-common-props :field="field" @changeProp="changeProp" />

    <b-form-group label-cols="3" label="Add Button Text">
      <b-form-input @change="changeProp" v-model="field.add_text" />
    </b-form-group>
    <b-form-group label-cols="3" label="Length">
      <div class="row d-flex align-items-baseline">
        <div class="col-4">
          <b-form-input
            @change="changeProp"
            min="0"
            step="1"
            type="number"
            v-model="field.params.min"
          />
        </div>
        <div class="col-2 align-middle">To</div>
        <div class="col-4">
          <b-form-input
            @change="changeProp"
            min="0"
            step="1"
            type="number"
            v-model="field.params.max"
          />
        </div>
      </div>
    </b-form-group>

    <b-form-group label-cols="3" label="Max. Entries">
      <b-form-input
        @change="changeProp"
        min="0"
        step="1"
        type="number"
        v-model="field.params.max"
      />
    </b-form-group>
    <b-form-group label-cols="3" label="Min. Entries">
      <b-form-input
        @change="changeProp"
        min="0"
        step="1"
        type="number"
        v-model="field.params.min"
      />
    </b-form-group>
    <b-form-group label-cols="3" label="Widgets">
      <f-child-fields
        :fields="field.fields"
        @change="on_changed_fields"
        @select="on_select"
      />
    </b-form-group>
  </span>
</template>

<script>
import WidgetCommonProps from "../WidgetCommonProps.vue";
import WidgetPropMixin from "../WidgetPropMixin.js";
import FChildFields from "../FChildFields.vue";

export default {
  name: "TableProps",
  components: { FChildFields, WidgetCommonProps },
  mixins: [WidgetPropMixin],
};
</script>
